import React from 'react';
import './HomeHeader.css'
const HomeHeader = () => {
    return (
        <div className='home-container'>
            <div className='home-title'>
                <h1>Buy your favourite Laptop</h1>
                <p>Buy latest Laptop at best price in Bangladesh. Get your Laptop Accessories from our online shopping store  COD. EMI. Easy Return. Shop Now.</p>
            </div>
            <img src="https://i.ibb.co/BPbGCDZ/laptop4.jpg" alt="" />
        </div>
    );
};

export default HomeHeader;